import { type ComponentProps, useEffect } from 'react';
import { useErrorBoundary } from 'react-error-boundary';
import { useLocation } from 'react-router';

import ErrorTemplate from './error-template';

type IProps = Omit<ComponentProps<typeof ErrorTemplate>, 'type'>;

const Oops: React.FC<IProps> = ({ ...props }) => {
  const location = useLocation();
  const { resetBoundary } = useErrorBoundary();

  useEffect(() => {
    return () => {
      if (location.pathname !== window.location.pathname) resetBoundary();
    };
  }, [location]);

  return <ErrorTemplate type="oops" {...props} />;
};

export default Oops;
